import React from 'react';
import { Card } from '../Card';
import './maintainance.css';

type MaintainanceProps = {
    message?: string;
};

export const Maintainance: React.FC<MaintainanceProps> = ({
    message = 'Tính năng hiện tại đang tạm bảo trì để nâng cấp ở Phase 2.',
}) => {
    return (
        <Card style='h-full w-full !mb-0'>
            <div className='flex h-full w-full flex-col items-center justify-center px-6 text-center'>
                <svg
                    className='maintenance-worker mb-8'
                    viewBox='0 0 240 260'
                    width='240'
                    height='260'
                    aria-hidden
                >
                    <g transform='translate(36 48)'>
                        <g className='worker-gear'>
                            <rect x='-6' y='-28' width='12' height='56' rx='2' fill='#C5D0DC' />
                            <rect x='-28' y='-6' width='56' height='12' rx='2' fill='#C5D0DC' />
                            <g transform='rotate(45)'>
                                <rect x='-6' y='-28' width='12' height='56' rx='2' fill='#C5D0DC' />
                                <rect x='-28' y='-6' width='56' height='12' rx='2' fill='#C5D0DC' />
                            </g>
                            <circle r='18' fill='#E8EEF5' stroke='#C5D0DC' strokeWidth='3' />
                            <circle r='7' fill='#fff' stroke='#C5D0DC' strokeWidth='3' />
                        </g>
                    </g>
                    <g transform='translate(198 186)'>
                        <polygon points='0,-56 24,8 -24,8' fill='#F17A20' />
                        <polygon points='0,-46 15,8 -15,8' fill='#FFB25B' />
                        <rect x='-28' y='6' width='56' height='11' rx='2' fill='#EA580C' />
                        <rect x='-6' y='-20' width='12' height='9' rx='1' fill='#fff' />
                    </g>
                    <g className='worker-body'>
                        <rect x='88' y='198' width='22' height='12' rx='3' fill='#374151' />
                        <rect x='130' y='198' width='22' height='12' rx='3' fill='#374151' />
                        <rect x='92' y='150' width='16' height='52' rx='6' fill='#1E3A5F' />
                        <rect x='132' y='150' width='16' height='52' rx='6' fill='#1E3A5F' />
                        <rect x='86' y='108' width='68' height='54' rx='12' fill='#F17A20' />
                        <rect x='98' y='118' width='44' height='36' rx='6' fill='#FFE7CC' />
                        <circle cx='120' cy='84' r='24' fill='#F8D7B8' />
                        <ellipse cx='112' cy='82' rx='2.4' ry='2.8' fill='#3F3F46' />
                        <ellipse cx='128' cy='82' rx='2.4' ry='2.8' fill='#3F3F46' />
                        <path d='M112 94 Q120 101 128 94' fill='none' stroke='#C08457' strokeWidth='2' strokeLinecap='round' />
                        <path d='M94 74 Q120 42 146 74 L146 84 Q120 56 94 84 Z' fill='#FBBF24' />
                        <rect x='86' y='74' width='68' height='10' rx='5' fill='#F59E0B' />
                        <g className='worker-left-arm'>
                            <rect x='62' y='118' width='28' height='12' rx='6' fill='#F8D7B8' />
                            <rect x='52' y='126' width='14' height='30' rx='7' fill='#F8D7B8' />
                        </g>
                        <g className='worker-arm'>
                            <rect x='148' y='116' width='40' height='12' rx='6' fill='#F8D7B8' />
                            <rect x='178' y='86' width='10' height='56' rx='4' fill='#6B7280' />
                            <path d='M173 76 h20 a11 11 0 0 1 0 22 h-8 v-8 h-4 v8 h-8 a11 11 0 0 1 0-22 z' fill='#9CA3AF' />
                        </g>
                    </g>
                    <g className='worker-sparks'>
                        <circle cx='204' cy='78' r='3.5' fill='#FBBF24' />
                        <circle cx='216' cy='92' r='2.5' fill='#F59E0B' />
                        <circle cx='192' cy='68' r='2' fill='#FDE68A' />
                    </g>
                </svg>
                <p className='max-w-2xl text-2xl font-medium text-gray-700'>
                    {message}
                </p>
            </div>
        </Card>
    );
};
